import React from 'react';
import { Link } from 'react-router-dom';


const PracticeAreasTwo = () => {
    return(
        <>
        {/* Practice Areas Section */}
        <section className="practice-areas-section section-padding-four">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="sec-o-title text-center pb-3">
                    <h2 className="transform-uppercase">practice <span>areas</span></h2>
                </div>
                </div>
            </div>
            <div className="row clearfix mb-4">
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-legal-hammer-black-silhouette" /><Link to="#">Bank &amp; Financial</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-courthouse" /><Link to="#">Tax &amp; Business Law</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-sports-car" /><Link to="#">Car Accidents</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-home" /><Link to="#">Property law</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-sex-1" /><Link to="#">Criminal Defense</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-wheel-chair" /><Link to="#">Personal Injury</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-briefcase" /><Link to="#">Corporate Law</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-correct" /><Link to="#">Wrongful Death</Link></div>
                </div>
                <div className="col-lg-4">
                <div className="practice-areas-details mb-4"><i className="flaticon-boy-and-girl-students" /><Link to="#">Child Labor</Link></div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="button-box text-center">
                    <Link to="#" className="o-btn btn-style-ten">Load More</Link>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Practice Areas Section*/}
        </>
    )
}

export default PracticeAreasTwo;